import { CartesianGrid as RechartsCartesianGrid } from "recharts";

export function CartesianGrid() {
	/** Render */
	return (
		<RechartsCartesianGrid
			vertical={false}
			className="stroke-primaryGray-100 dark:stroke-primaryGray-800"
		/>
	);
}
